import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTE_SOURCES } from 'src/constants/routeSources';

export const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handlePrivacyClick = () => {
    navigate(`/${ROUTE_SOURCES.PRIVACY}`);
  };

  const handleTermsClick = () => {
    navigate(`/${ROUTE_SOURCES.TERMS}`);
  };

  return (
    <Box
      component="footer"
      sx={{
        marginTop: '40px',
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: '12px',
        padding: '20px 0',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: '12px',
          marginBottom: '8px',
          fontWeight: 500,
          color: 'rgba(0, 0, 0, 0.7)',
        }}
      >
        Kipify S.R.L. VAT 03912000548
      </Typography>

      <Box sx={{ marginBottom: '8px' }}>
        <Link
          component="button"
          onClick={handlePrivacyClick}
          sx={{
            color: 'rgba(0, 0, 0, 0.6)',
            textDecoration: 'underline',
            cursor: 'pointer',
            marginRight: '12px',
            fontSize: '12px',
            '&:hover': {
              color: 'rgba(0, 0, 0, 0.8)',
            },
          }}
        >
          Privacy Policy
        </Link>
        <Link
          component="button"
          onClick={handleTermsClick}
          sx={{
            color: 'rgba(0, 0, 0, 0.6)',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '12px',
            '&:hover': {
              color: 'rgba(0, 0, 0, 0.8)',
            },
          }}
        >
          Terms and Conditions
        </Link>
      </Box>

      <Typography
        variant="body2"
        sx={{
          fontSize: '12px',
          color: 'rgba(0, 0, 0, 0.5)',
        }}
      >
        © 2025 Kipify S.R.L. All rights reserved
      </Typography>
    </Box>
  );
};
